/*
 VUEX module for activeCampaign management
 */
import axios from 'axios'
import Vue from 'vue'
import {
  ERROR
} from '@/constants/store'

const MYCAVALOR_URL = 'https://www.mycavalor.com/mycavalor'
const MYCAVALOR_TOOL_LIST = '8'

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    contact: undefined,
    // Mapping of language to tags
    langTag: {
      'nl': 4,
      'fr': 13,
      'en': 12,
      'de': 20
    },
    // Mapping between internal MyCavalor activityTypeIdx and ActiveCampaign tag-ids
    tags: {
      // Muscle
      36: 26,
      // Muscle growth
      35: 94,
      // Joint problems
      14: 95,
      // Coughing (respiratory problems)
      18: 96,
      // Hoof problems
      17: 23,
      // Laminitis
      16: 30,
      // Sensitive to IR
      20: 31,
      // IR & decrease bodyweight
      19: 31,
      // Body condition low
      28: 97,
      // Overweight (decrease bodyweight)
      30: 98,
      // Obesitas
      29: 98,
      // Gastric ulcers
      25: 99,
      // Colic-sensitive
      21: 100,
      // Poor hair condition
      34: 101,
      // Liver problems
      24: 102,
      // Kidney problems
      27: 103,
      // Stress
      39: 104,
      // Excessive sweating
      31: 105,
      // Decreased immunity status
      40: 106,
      // Long transport duration
      23: 107,
      // Excess energy
      45: 108,
      // Too little energy - not explicitly represented - special card
      46: 109,
      // Recovery colic surgery
      41: 110,
      // --------------- Activities -------------------
      // Jumping
      38: 122,
      // Dressuur
      9: 123,
      // Eventing
      11: 124,
      // Driving,
      26: 130,
      // Endurance
      10: 125,
      // Reining
      33: 126,
      // Cutting
      6: 127,
      // Barrel racing
      5: 128,
      // Pleasure
      43: 118,
      // Leisure
      32: 117
    },
    // Topsport: 116
    // Sport: 115
    activityIdxTags: {
      // Showjumping, > 130cm
      18: 116,
      // Showjumping, < 120cm
      15: 115,
      // Dressuur - intermediate
      34: 115,
      // Dressuur - International
      // Eventing - Internationaal
      // Driving - Internationaal
      27: 116,
      // Eventing - Nationaal
      // Driving - Nationaal
      28: 115,
      // Endurance - > 160 km
      19: 116,
      // Endurance - < 120 km
      16: 115,
      // Reining - Advanced level
      25: 116,
      // Reining - Amateur
      21: 115,
      // Cutting - Competitie
      // Barrel racing - Competitie
      24: 116,
      // Cutting - Training
      // Barrel racing - Training
      36: 115,
      // Leisure - rest
      32: 119,
      // Leisure - riding
      37: 120,
      // Leisure - outdoor riding
      41: 121
    }
  },
  // -----------------------------------------------------------------
  getters: {
  },
  // -----------------------------------------------------------------
  mutations: {
    setAcContact: (state, user) => {
      Vue.set(state, 'contact', user)
    }
  },
  // -----------------------------------------------------------------
  actions: {
    async getUserByEmail ({ commit, state, dispatch }, { email }) {
      try {
        const {data} = await axios.get(`${MYCAVALOR_URL}/ac/contacts/search/${email}`)
        const contact = data.contacts[0] || undefined
        commit('setAcContact', contact)
        return contact
      } catch (error) {
        commit(ERROR, { message: error }, { root: true })
      }
    },
    async createUser ({ commit, state }, { email, name, phone }) {
      try {
        const { data } = await axios.post(`${MYCAVALOR_URL}/ac/contacts`, { contact: { email, lastName: name, phone } })
        const contact = data.contact || undefined
        commit('setAcContact', contact)
        return contact
      } catch (error) {
        commit(ERROR, { message: error }, { root: true })
      }
    },
    async addToMyCavalorList ({ commit }, { id }) {
      try {
        const { data } = await axios.post(`${MYCAVALOR_URL}/ac/contactLists`, { contactList: { list: MYCAVALOR_TOOL_LIST, contact: id, status: '1' } })
        return data.contactList
      } catch (error) {
        commit(ERROR, { message: error }, { root: true })
      }
    },
    async addTag ({ commit, state }, contactTag) {
      try {
        const { data } = await axios.post(`${MYCAVALOR_URL}/ac/contactTags`, contactTag)
        return data.contactTag
      } catch (error) {
        commit(ERROR, { message: error }, { root: true })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/activecampaign.js